import ApiClient from '../../base/api';
import { FindCityRequestParams, FindSpecialityRequestParams } from '../../base/interfaces/api';
import { City, Speciality } from '../../base/interfaces/config';
import { ConfigResponseData } from './interfaces';

const apiClient = new ApiClient();

export const employerApi = {
    getConfig: () => apiClient.get<ConfigResponseData>('/api/config'),
    findCity: (data: FindCityRequestParams, signal?: AbortSignal) =>
        apiClient.post<FindCityRequestParams, City[]>('/api/find-city', data, { signal }),
    findSpeciality: (data: FindSpecialityRequestParams, signal?: AbortSignal) =>
        apiClient.post<FindSpecialityRequestParams, Speciality[]>('/api/find-speciality', data, { signal }),
};
